module.exports = __webpack_public_path__ + "img/PR.c392f150.png";